import { StyleRules } from '@mui/styles';

const styles = (): StyleRules => ({
    root: {
        height: '100vh',
        background: '#fafafa',
    },
    content: {
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        width: '1200px',
    },
});

export default styles;
